import React, { useState } from 'react'

import { Button, Grid, Menu, MenuItem, Pagination } from '@mui/material'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { gridSpacing } from 'store/constant';
import { useTheme } from '@mui/material/styles';

const PaginationRows = ({ total, page = 1, setPage, limit, setLimit, limits }) => {

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const limitHandler = (value) => {
        setPage(1)
        setLimit(value)
        handleClose()
    }
    const changePageHandler = (event, selectedPage) => {
        setPage(selectedPage)
    }

    return (
        <Grid container justifyContent="space-between" spacing={gridSpacing} sx={{ p: 3 }}>
            <Grid item>
                <Button
                    size="large"
                    sx={{ color: theme.palette.grey[900] }}
                    color="secondary"
                    endIcon={<ExpandMoreRoundedIcon />}
                    onClick={handleClick}
                >
                    {limit} Rows
                </Button>
                {anchorEl && (
                    <Menu
                        id="menu-user-list-style1"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        variant="selectedMenu"
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                    >
                        {limits.map((value) => {
                            return <MenuItem key={value} onClick={() => limitHandler(value)}> {value} Rows</MenuItem>
                        })}
                    </Menu>
                )}
            </Grid>
            <Grid item>
                <Pagination onChange={changePageHandler} page={page} count={Math.ceil(total / limit)} color="primary" />
            </Grid>
        </Grid>
    )
}

export default PaginationRows;
